import { z } from 'zod';

import { UuidSchema } from '../../common/id/id';
import { makeListQuery } from '../../common/list-query/list-query';
import { EntitlementStoreSchema } from '../entitlement-store/entitlement-store';
import { PAYMENT_EXTERNAL_REF_MAX_LENGTH } from '../payment/payment';
import { PaymentKindSchema } from '../payment-kind/payment-kind';
import { PaymentSourceSchema } from '../payment-source/payment-source';
import { PaymentStatusSchema } from '../payment-status/payment-status';

/**
 * The ledger's staff list (P31): every filter is a whitelisted column (N7).
 *
 * No `search`. A member is found through the kit's server-searched picker and
 * then filtered by `userId` — the shape every billing list keeps, and the one
 * P27c2 learned the hard way: a `?search=<email>` link to a list whose contract
 * has no `search` answers 400. `externalRef` is exact, because the question it
 * answers is a dispute's ("find transaction X"), never a browse.
 *
 * `from`/`to` bound `occurredAt` — when the money moved, not when the row was
 * written, since a backfill writes yesterday's movements today.
 */
export const PaymentsListQuerySchema = makeListQuery({
  store: EntitlementStoreSchema.optional(),
  status: PaymentStatusSchema.optional(),
  kind: PaymentKindSchema.optional(),
  source: PaymentSourceSchema.optional(),
  userId: UuidSchema.optional(),
  externalRef: z.string().trim().min(1).max(PAYMENT_EXTERNAL_REF_MAX_LENGTH).optional(),
  from: z.iso.datetime().optional(),
  to: z.iso.datetime().optional(),
});

export type PaymentsListQuery = z.infer<typeof PaymentsListQuerySchema>;
